import { Observable } from 'rxjs';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';

export abstract class TokenSaverService {

    abstract auth(rut: number, ci: string, tokenCaptcha: string, dispositivoMobile: boolean, idEjecutivo: number): Observable<GeneralResponse<any>>;
    abstract authLogin(rut: number, correo: string, telefono: number, producto: string, tokenCaptcha: string, dispositivoMobile: boolean, idEjecutivo:number,isMarketplaceSVA?:boolean): Observable<GeneralResponse<any>>;
    abstract getToken(): string;
    abstract saveToken(token: string): void;
    abstract sessionEnd();
}
